
export default {
    'asset.title': 'Portfolio Value in',
    'asset.cash': 'Cash',
    'asset.market': 'Holdings',
    'asset.max.power': 'Max MBP ',
    'user.Financing.risk': 'Margin',
    'user.save': 'Safe',
    'user.jingjie': 'Alert',
    'user.zhuijiao': 'Margin Call',
    'user.Forced.ping': 'Margin Closeout',
    'asset.card.buy': 'Buy',
    'asset.card.sell': 'Sell',
    'asset.recharge': 'Deposit',
    'asset.withdraw': 'Withdraw',
    'asset.exchange': 'Exchange',
    'asset.cash.detail':'Cash Details',
    'asset.capitalFlow': 'Cash Flow',
    'asset.assetRecord': 'In/Outflow',
    'user.Position': 'Positions',
    'asset.section2.title': 'Orders',
    'asset.section3.title': 'Statements',
    'user.Position.price': 'Price | Vol',
    'user.Position.pv': 'PV | MV',
    'asset.section1.table8': 'P/L',

    'asset.his.all': 'All',
    'asset.his.buy': 'Buy/',
    'asset.his.sell': 'Sell/',
    'asset.his.exer': 'Exer',
    'asset.his.done': 'Done',
    'asset.his.tab1': 'Trade order',
    'asset.his.tab2': 'Subscription order',
    'asset.his.tab3': 'Stock',
    'asset.his.tab4': 'US Options',
    'asset.his.tab5': 'IPO',
    'asset.his.type': 'Type',
    'asset.his.date': 'Date',
    'asset.his.status': 'Status',
    'asset.his.apply.price': 'Price',
    'asset.his.apply.ipo.price': 'Price',
    'asset.his.amount': 'Qty',
    'asset.his.ipo.deal': 'Deal',
    'asset.his.trans.deal': 'Deal',
    'asset.table.market.price': 'Mkt Price',
    'asset.order.change':'Modify',
    'asset.order.cancel': 'Cancel',
    'member.price': 'Price',
    'asset.order.cancel.confirm': 'Confirm to cancel?',
    'asset.history.detai.t': 'Charge Statements',
    'asset.history.detai.item1': 'Commission',
    'asset.history.detai.item2': 'Stamp Duty',
    'asset.history.detai.item3': 'Registration fee',
    'asset.history.detai.item4': 'SFC transaction levy',
    'asset.history.detai.item5': 'Trading Fee',
    'asset.history.detai.item6': 'Trading Fee',
    'asset.history.detai.item7': 'Transaction Levy',
    'asset.history.detai.item8': 'Settlement Fee',
    'asset.history.detai.item9': 'Trading Fee',
    'asset.history.detai.item10': 'Transaction Levy',
    'asset.history.detai.item11': 'Transaction Levy',
    'asset.history.detai.item12': 'Clearing Fee',
    'asset.history.detai.item13': 'Clearing Fee',
    'asset.history.detai.item14': 'System Fee',
    'asset.history.detai.item15': 'Grey Market Commission',
    'asset.table.more': 'More',

    'history.list.status.1': 'All',
    'history.list.status.2': 'Filled',
    'history.list.status.3': 'Cancelled',
    'history.list.status.4': 'Partial Filled/Cancelled',
    'history.list.status.5': 'Inactive',
    'history.list.status.Bid': 'Bid',
    'history.list.status.Offer': 'Offer',
    'history.list.status.Exercise': 'Exercise',
    'history.list.status.Inactive': 'Inactive',
    'history.list.status.Filled': 'Filled',
    'asset.has.awarded': 'Alloted',
    'asset.not.awarded': 'Unalloted',
    'asset.logout.title':'One Account, All Things Investing',
    'asset.logout.title.desc':'Create your WBroker account and start your first',
    'asset.page.desc':'Provide Premium Investments for HK/US/A share markets',
    'asset.open.account':'Open Acc.',
    'asset.logout.has.account.1':'WBroker Account already exists. Please ',
    'asset.logout.has.account.2':'Click here to Login',
    'asset.logout.has.account.3':'',
    //已有WBroker账户，请点此登录
    'asset.logout.desc.item1':'Same-day withdrawal and 7*24 deposit',
    'asset.logout.desc.item2':'0 Threshold 10 Minutes Open Account Online',
    'asset.logout.desc.item3':'HK/US/A shares trading available',
    'asset.processing.step1':'Sign Up',
    'asset.processing.step1.desc':'Submission time',
    'asset.processing.step2':'Approve',
    'asset.processing.step2.desc':'About 1 hour (working day)',
    'asset.processing.step3':'Account opened successfully',

    //入金
    'recharge.digital': 'Deposit Stablecoin',
    'asset.recharge.USDT': 'Deposit USDT',
    'recharge.USDC': 'Deposit USDC',
    'asset.HKD': 'HKD',
    'asset.USD': 'USD',
    'asset.CNY': 'CNY',
    'asset.recharge.min.tip': 'Your deposit shall exceed ',
    'asset.recharge.min.tip1': 'Your deposit shall exceed the commission fee',
    'user.btn.sibmit': 'Submit',
    'recharge.currency': 'Type',
    'asset.recharge.chainName': 'Chain Name',
    'asset.recharge.feeRate': 'Commission:',
    'asset.recharge.amount': 'Amount',
    'asset.recharge.amount.placeHolder': 'Enter amount',
    'asset.recharge.amount.min': 'Enter amount',
    'asset.recharge.fee': 'Estimated fee: ',
    'asset.recharge.toAmount': 'Into',
    'asset.rate': 'Exchange rate: ',
    'asset.recharge.address': 'Address:',
    'asset.recharge.click': 'Click to ',
    'asset.recharge.click.2': 'cpoy',
    'asset.tips.title': 'Notes:',
    'asset.recharge.tips1': '1.Before proceeding, please confirm that you have read and would adhere to ',
    'asset.recharge.tips2': 'Terms of Use',
    'asset.recharge.tips3': '. If you encounter any difficulty in deposit process, please do not hesitate to contact 24/7 customer service team.',
    'asset.recharge.tips4': '2.Typically, your deposit will be be completed within 10 minutes.',
    'asset.recharge.tips5': '3.WBroker doesn’t support deposit from contract address.',
    'recharge.important.tip4': '4.Please confirm the address of your chain when transferring. If you transfer to the wrong chain, you will lose 5%-10% of the deposit amount and being charged no less than 200 USDT fee or you may not be able to recover it.',
    'user.copy.success': 'Copied',
    'shareImg.long.press': 'Tap and hold',
    'shareImg.long.press.1': ' to save pic',
    'asset.resultTipA': 'Your deposit is supposed to land within 10 minutes. We will inform you immediately after the deposit is completed.',
    'lend.result.contact': 'If you need any help, please ',
    'lend.result.contact.servers': 'contact customer sevices',
    'user.back': 'Back',
    'user.contact.servers': 'customer sevices',

    //出金
    'asset.order.tip.max': 'Your withdrawal shall not exceed available cash',
    'asset.order.tip.min': 'Your withdrawal shall exceed commission fee',
    'user.getVerifyCodeFirst': 'Send verification code',
    'withdraw.auth.address':'请先认证出金地址',
    'asset.withdraw.currency': 'Into',
    'asset.withdraw.amount.balance': 'Available:',
    'asset.withdraw.amount': 'Amount',
    'asset.withdraw.amount.placeholder': 'Enter',
    'withdraw.all': 'All',
    'asset.withdraw.toAmount': 'Exchange into',
    'asset.withdraw.percentage': 'Exchange rate',
    'asset.withdraw.feeRate': 'Fee:',
    'withdraw.to': 'Send to',
    'user.withdraw.change.address': 'Modify withdraw address',
    'asset.withdraw.not.auth': 'Unverified',
    'asset.withdraw.auth.address': 'verify address',
    'user.forget.trcPsw': 'Forgot PIN？',
    'asset.withdraw.tips1': '1. Withdrawal applications before 16:00 on business days will be completed on the same day; Applications after 16:00 will be completed by 24:00 of the next business day; It will be postponed on holidays and weekends.',
    'asset.withdraw.tips2': '2. HK/US stock trading settles up in two business days (T+2).',
    'setting.not.bind.mobile': 'You have not bound the phone, please bind the phone first',
    'setting.not.bind.email': 'You have not bound the e-mail address, please bind the e-mail address first',
    'asset.resultTipB': 'Your application for withdrawal is submitted.',
    'withdraw.title.new': 'Withdraw',
    'asset.withdraw.result': '*Withdrawal applications before 16:00 on business days will be completed on the same day; Applications after 16:00 will be completed by 24:00 of the next business day; It will be postponed on holidays and weekends.',

    //换汇
    'asset.outAmount': 'From',
    'asset.maxCan': 'MAX',
    'asset.finishOutAmount': 'Enter amount',
    'asset.allExchange': 'All',
    'asset.afterExchangeBalance': 'Balance ',
    'asset.inAmount': 'Into',
    'asset.record.exchange': 'Exchange',
    'exchange.bottom.tip1': '1.The exchange rate below is for general reference only. The actual exchange rate shall prevail.',
    'exchange.bottom.tip2': '2.Assets under settlement and liquidation cannot be exchanged. Typically, stocks settlement and liquidation could be completed in 2 days.',

    //换汇记录
    'exchange.record.title': 'Exchange  History',
    'exchange.record.direction': 'Direction',
    'exchange.record.table1': 'Date',
    'exchange.record.table2': 'Out',
    'exchange.record.table3': 'In',
    'exchange.record.table4': 'Rate',
    'exchange.record.direction1': 'HKD to USD',
    'exchange.record.direction2': 'HKD to CNY',
    'exchange.record.direction3': 'USD to HKD',
    'exchange.record.direction4': 'USD to CNY',
    'exchange.record.direction5': 'CNY to HKD',
    'exchange.record.direction6': 'CNY to USD',

    //资金明细
    'asset.detail.title1.HKD': 'Securities Account (HKD)',
    'asset.detail.mainItem1': 'Portfolio Value',
    'asset.detail.mainItem2': 'Cash',
    'asset.detail.mainItem3': 'Holdings',
    'asset.detail.mainItem4': 'CNY',
    'asset.detail.mainItem5': 'USD',
    'asset.detail.mainItem6': 'HKD',
    'asset.detail.mainItem7': 'Frozen',
    'asset.detail.mainItem8': 'Available cash',
    'asset.detail.title3': 'Margin Risk Management',
    'asset.detail.mainItem9': 'Max MBP',
    'asset.detail.mainItem10': 'Margin Risk',

    //融资明细
    'asset.financing': 'Margin',
    'asset.financing.totalFinanceBuyPower': 'Max Margin Buying Power',
    'asset.financing.debtBalance': 'Debt Balance',
    'asset.financing.marginValue': 'Holdings Collateral',
    'asset.financing.marginRatioPlus': 'Margin',
    'asset.financing.marginCall': 'Margin Call',
    'asset.financing.HKCash': 'Balance (HKD)',
    'asset.financing.USCash': 'Balance (USD)',
    'asset.financing.CNYCash': 'Balance (CNY)',
    'asset.financing.table1': 'Position',
    'asset.financing.table2': 'MV',
    'asset.financing.table3': 'Collateral Rate',
    'asset.financing.table4': 'Collateral Value',
    'asset.financing.detail.tip1': '1. Debt Balance = total balance of all currencies. Holdings Collateral = total value of all stock collaterals. Margin Risk = Debt Balance / Holdings Collateral. Margin Call = Debt Balance - Holdings Collateral*85%.',
    'asset.financing.detail.tip2': '2. Alert: risk＞70%. Margin Call: risk＞90%. Margin Closeout: risk＞105%.',
    'asset.financing.detail.tip3': '3. Margin call may not always be made before margin closeout. Please keep tabs on the market and risks. You can make margin call or close by yourself.',
    'asset.financing.detail.tip4': '4. Margin closeout could be partial or whole at discretion.',
    'asset.financing.detail.tip5': '5. Account with portfolio value below 3000HKD is off from margin access and could be closeout.',
    'asset.financing.detail.tip6': '6. 100HKD will be charged if margin closeout happens.',

    //出入金流水
    'user.option.success': 'Success!',
    'asset.time': 'Time',
    'asset.recharge.record.amount': 'Amount',
    'asset.exchange.amount': 'Exchange',
    'asset.status': 'Status',
    'asset.record.status1': 'TBConfirmed',
    'asset.record.status2': 'Completed',
    'asset.record.status3': 'Uncompleted',
    'asset.record.status4': 'Canceled',
    'asset.record.status5': 'New',
    'asset.record.status6': 'TBDeducted',
    'asset.record.status7': 'Deducted',
    'asset.record.status8': 'TBPaid',
    'asset.record.status9': 'Cancel',
    'asset.record.status10': 'Rejected',
    'asset.record.currencyCode': 'Exchange',
    'asset.withdraw.record.amount': 'Amount',
    'asset.exchange.withdraw.amount': 'Exchange',
    'asset.currency': 'Currency',
    'asset.recharge.detail': 'Deposit details',
    'asset.withdraw.detail': 'Withdrawal details',
    'asset.type': 'Type',
    'asset.chainType3': 'WICC',
    'asset.detail.amount': 'Amount',
    'asset.hash': 'Hash',
    'asset.from.address': 'From',
    'asset.to.address': 'To',
    'asset.fee': 'Commission fee',
    'asset.reject': 'Apply to reject',
    'asset.reject.tip1': 'The withdrawal is under the settlement. You can cancel withdrawal for ',
    'asset.reject.tip2': ' times today. Confirm to cancel?',
    'asset.reject.confirm': 'Confirm',

}
